/**
 * One size for every checkbox and radio button, so a choice list never mixes a small tick box with a
 * bigger radio. Big on purpose: these are tapped on phones. Used by Checkbox, RadioGroupItem and the
 * Questionnaire choice indicator.
 */
export const CHOICE_CONTROL_SIZE = "size-7";

/** Inner mark sizes that sit inside CHOICE_CONTROL_SIZE. */
export const CHOICE_CONTROL_TICK_SIZE = "size-5";
export const CHOICE_CONTROL_DOT_SIZE = "size-3.5";
